import LocalStorageService from './LocalStorageService'
import PostService from './PostService'
import UtilService from './UtilService'

export default class TokenService {
  constructor() {
    this.localStorageService = new LocalStorageService()
    this.postService = new PostService(this, false)
    this.util = new UtilService(true)
  }

  IniciarValidacao(callback) {
    if (!this.TokenSession()) {
      if (this.TokenQueryString()) {
        let tk = this.TokenQueryString()
        console.log("Token registrado:" + tk)
        this.UpdateTokenSession(tk)
        this.ValidarToken(this.TokenSession(), callback)
      } else {
        this.util.RedirectLogin(true)
      }
    } else {
      this.ValidarToken(this.TokenSession(), callback)
    }
  }

  ValidarToken(token, callback) {    
    let url = process.env.VUE_APP_URL_LOGIN + 'api/Account/ValidarToken?token=' + token
    this.postService.Get(url, (res) => {      
      if(!res.TokenValido) {
        this.util.RedirectLogin(false)
      } else {
        this.localStorageService.Set(process.env.VUE_APP_CPF_LOGIN_ATUAL, res.CPF, true)
        this.ValidarPermissao(token, callback)
      }
    }, (erro) => {
      console.log(erro, url)
      this.util.RedirectLogout(false)
    })
  }

  ValidarPermissao(token, callback, identificador) {
    let ref = this
    let url = process.env.VUE_APP_URL_LOGIN + 'api/account/getclaim?token={token}&identificador={identificador}'    
    if(!identificador) {
      url = url.replace('{token}', token).replace('{identificador}', process.env.VUE_APP_IDENTIFICADOR_HOTEL_SYS)
    }
    else{
      url = url.replace('{token}', token).replace('{identificador}', identificador )
    }
    this.postService.Get(url, (res) => {      
      this.localStorageService.Set(process.env.VUE_APP_MY_CLAIMS, res.MyClaims)  
      if(res.MyClaims.filter(x => x.Value === 'conectado' || x.Value === 'administrador').length === 0) {
        if(identificador)
          this.util.RedirectLogin(false)
        else
          this.ValidarPermissao(token,callback,"funcionariocbtur")
      } else if(callback) {        
        let old = ref.localStorageService.Get(process.env.VUE_APP_USUARIO_LOGADO)
        if (old && old.PessoaID === res.PessoaAuth.PessoaID) {          
          res.PessoaAuth.eFuncionario = old.eFuncionario          
        }
        this.localStorageService.Set(process.env.VUE_APP_USUARIO_LOGADO, res.PessoaAuth)
        callback(token)
      }
    })
  }
  
  getParameterByName(name) {
    let url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  
  /** @return {string} */
  TokenQueryString() {
    return this.getParameterByName('token')
  }

  /** @return {string} */
  TokenSession() {
    return this.localStorageService.Get(process.env.VUE_APP_KEY_SESSION_TOKEN,true)
  }

  UpdateTokenSession(token) {
    this.localStorageService.Set(process.env.VUE_APP_KEY_SESSION_TOKEN, token, true)
  }
}
